import type { ColumnFilters, FilterValue } from '@/components/project-filter-sheet';

/**
 * Whether a filter actually constrains the result set. Mirrors the active-filter
 * rules used by countActiveFilters/applyColumnFilters so the badge count, the
 * client-side filtering and the server request always agree.
 */
function isActive(filter: FilterValue): boolean {
  switch (filter.kind) {
    case 'multi-select':
      return filter.selected.length > 0;
    case 'numeric-range':
      return filter.min !== undefined || filter.max !== undefined || filter.value !== undefined;
    case 'text':
      return filter.value.trim() !== '';
  }
}

/**
 * Serialise the active column filters for the projects API, which applies them in
 * SQL. Returns undefined when nothing is active so the request stays unchanged.
 */
export function serialiseColumnFilters(filters: ColumnFilters): string | undefined {
  const active = Object.entries(filters).filter(([, filter]) => isActive(filter));
  if (active.length === 0) return undefined;
  return JSON.stringify(Object.fromEntries(active));
}
